export const UPLOAD_FAILED = 'upload_failed'
export const UPLOAD_TIMED_OUT = 'upload_timed_out'
export const READ_FILE_FAILED = 'read_file_failed'
export const EMPTY_FILE = 'empty_file'